import { Stack, Container, Typography } from '@mui/material';
import ExpiringTxTableView from 'src/sections/management/user/tabs/expiring-tx/expiring-tx-table-view';

export default function ExpiringTxView() {
  return (
    <Container>
      <Stack spacing={3}>
        <Typography variant="h4" gutterBottom>
          ธุรกรรมใกล้หมดอายุ
        </Typography>
        <ExpiringTxTableView />
      </Stack>
    </Container>
  );
}
